export const lang = {
    
    // 英语
    'en-us': {
        'title': 'Game of Empires: Warring Realms',
        'keyWords': 'Empires、game、game of empires、rise of empires、rise of kingdom、age of empires、king of avalon、age、rise、king、the Three Kingdoms、history',
        'description': "In GOE, you can choose a civilization with whom you can explore a world you're free to conquer. In doing so, you can establish an empire and immerse yourself in different multilayered stories as you discover ancient civilizations, all while setting forth on an epic expedition towards the fabled Atlantis!",
        'termText': 'TERMS OF USE',
        'privacyText': 'PRIVACY POLICY',
        'wait': 'Stay tuned!',
    },
    // 法语
    'fr-fr': {
        'title': 'Game of Empires: Warring Realms',
        'keyWords': 'Empires、game、game of empires、rise of empires、rise of kingdom、age of empires、king of avalon、age、rise、king、the Three Kingdoms、history',
        'description': "In GOE, you can choose a civilization with whom you can explore a world you're free to conquer. In doing so, you can establish an empire and immerse yourself in different multilayered stories as you discover ancient civilizations, all while setting forth on an epic expedition towards the fabled Atlantis!",
        'termText': 'Termes et Conditions',
        'privacyText': 'Politique de confidentialité',
        'wait': 'Restez à l’affût !',
    },
    // 俄语
    'ru-ru': {
        'title': 'Game of Empires: Warring Realms',
        'keyWords': 'Empires、game、game of empires、rise of empires、rise of kingdom、age of empires、king of avalon、age、rise、king、the Three Kingdoms、history',
        'description': "In GOE, you can choose a civilization with whom you can explore a world you're free to conquer. In doing so, you can establish an empire and immerse yourself in different multilayered stories as you discover ancient civilizations, all while setting forth on an epic expedition towards the fabled Atlantis!",
        'termText': 'Условия Использования',
        'privacyText': 'Политика Конфиденциальности',
        'wait': 'Пока нет содержания',
    },
    // 德语
    'de-de': {
        'title': 'Game of Empires: Warring Realms',
        'keyWords': 'Empires、game、game of empires、rise of empires、rise of kingdom、age of empires、king of avalon、age、rise、king、the Three Kingdoms、history',
        'description': "In GOE, you can choose a civilization with whom you can explore a world you're free to conquer. In doing so, you can establish an empire and immerse yourself in different multilayered stories as you discover ancient civilizations, all while setting forth on an epic expedition towards the fabled Atlantis!",
        'termText': 'Geschäftsbedingungen',
        'privacyText': 'Datenschutzrichtlinie',
        'wait': 'Bleib dran!',
    },
}

